import DOMPurify from "isomorphic-dompurify";

export const sanitizeExcerptHtml = (html: string) =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["p", "br", "strong", "em", "b", "i"],
    ALLOWED_ATTR: [],
  });

// Whitelist only `text-align` and `margin-left` declarations in inline style
// attributes so we keep alignment + indent but strip every other inline style.
const STYLE_WHITELIST = /(^|;)\s*(text-align|margin-left)\s*:\s*[^;]+/gi;
const filterInlineStyle = (raw: string): string => {
  const kept: string[] = [];
  let m: RegExpExecArray | null;
  while ((m = STYLE_WHITELIST.exec(raw)) !== null) {
    kept.push(m[0].replace(/^;\s*/, "").trim());
  }
  return kept.join("; ");
};

let hookInstalled = false;
const ensureStyleHook = () => {
  if (hookInstalled) return;
  hookInstalled = true;
  DOMPurify.addHook("uponSanitizeAttribute", (_node, data) => {
    if (data.attrName !== "style") return;
    const filtered = filterInlineStyle(String(data.attrValue ?? ""));
    if (!filtered) {
      data.keepAttr = false;
      return;
    }
    data.attrValue = filtered;
  });
};

export const sanitizeCorpusHtml = (html: string) => {
  ensureStyleHook();
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "p", "br", "h2", "h3", "strong", "em", "b", "i", "u", "s",
      "ul", "ol", "li", "blockquote", "code", "pre", "a", "hr",
      "figure", "figcaption",
    ],
    ALLOWED_ATTR: [
      "href", "target", "rel", "class", "style",
      "data-media-id", "data-alt", "data-caption", "data-credit",
    ],
    ALLOWED_URI_REGEXP: /^(https?:|mailto:|tel:|\/|#)/i,
  });
};
